import { render, staticRenderFns } from "./day-article.vue?vue&type=template&id=1687936e"
import script from "./day-article.vue?vue&type=script&lang=js"
export * from "./day-article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports